import { render, staticRenderFns } from "./JcPayment.vue?vue&type=template&id=e8387244&scoped=true&"
import script from "./JcPayment.vue?vue&type=script&lang=js&"
export * from "./JcPayment.vue?vue&type=script&lang=js&"
import style0 from "./JcPayment.vue?vue&type=style&index=0&id=e8387244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8387244",
  null
  
)

export default component.exports